export function EditorChoiceBottomBorder(props) {
  return (
    <svg
      width="375"
      height="14"
      viewBox="0 0 375 14"
      preserveAspectRatio="none"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M375 0H374.835L0 0V11L19.7304 9.10561L36.8005 10.7137L60.1952 6.20588L83.6854 9.10561L97.789 6.20588L110.708 10.7132L138.313 9.10561L165.916 6.99776L189.279 12.2955C189.279 12.2955 200.529 8.41704 205.5 8.41704C210.471 8.41704 213 12.2955 216.871 12.2955C220.741 12.2955 242.454 5.47884 242.454 5.47884L266.626 6.99776L289.285 6.99776L333.08 14L359.15 9.10561L375 11V0Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  )
}

export function EditorChoiceTopBorder(props) {
  return (
    <svg
      width="375"
      height="14"
      viewBox="0 0 375 14"
      preserveAspectRatio="none"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14H0.164716H375V3L355.27 4.89439L338.199 3.28634L314.805 7.79412L291.315 4.89439L277.211 7.79412L264.292 3.28677L236.687 4.89439L209.084 7.00224L185.721 1.70454C185.721 1.70454 174.471 5.58296 169.5 5.58296C164.529 5.58296 162 1.70454 158.129 1.70454C154.259 1.70454 132.546 8.52116 132.546 8.52116L108.374 7.00224H85.715L41.9195 0L15.8503 4.89439L0 3L0 14Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  )
}
